import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getDeviceSchema } from '../../../../store/test-form-reducer';

import ILDeviceFields from './states/ILDeviceFields';
import PADeviceFields from './states/PADeviceFields';

const propTypes = {
  device: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

const DeviceStateFields = (props) => {
  if (props.schema.isEmpty()) { return null; }
  const { index, device } = props;
  const schema = props.schema.get('schema');
  const postalCode = props.schema.getIn(['state', 'postal_code']);

  switch (postalCode) {
    case 'PA':
      return <PADeviceFields schema={schema} index={index} />;
    case 'IL':
      return <ILDeviceFields schema={schema} device={device} index={index} />;
    default:
      return null;
  }
};

DeviceStateFields.propTypes = propTypes;

const mapStateToProps = state => ({
  schema: getDeviceSchema(state),
});

export default connect(mapStateToProps)(DeviceStateFields);



// WEBPACK FOOTER //
// ./src/features/test/TestForm/DeviceStateFields/DeviceStateFields.js